/**
 * @file VariationEditInvoice.js
 * @version 1.0.0
 * @author Cam Seymour
 * @project Excel Agri System
 * @created 2026-11-03
 * @modified 2026-11-03
 * @description "Edit invoice…" from Variation Review (Cam, 3 Nov 2026 —
 *              "those options should open in modals or at least return the
 *              user to where they were in step 2's table with their work still
 *              there on completion of save or cancel"). The invoice editor
 *              itself (CreateInvoice, every rule it has — the till's VAT-
 *              inclusive prices, posted editing and its reason, the prior-month
 *              question, the revised copy) in a window over the review: the
 *              editor is handed the invoice as every Edit hands it
 *              (sessionStorage 'editInvoiceId', read once on mount), and
 *              wherever the editor would go next — after a save, on Cancel —
 *              the window closes instead, back to the review exactly as it was.
 *
 *   Props: { invoice: { invoice_id, invoice_no, is_credit }, onClose() }.
 */

import React, { useState } from 'react';
import Modal from './Modal';
import CreateInvoice from './CreateInvoice';
import './VariationReview.css';

function VariationEditInvoice({ invoice, onClose }) {
  // Handed over before the editor mounts — CreateInvoice reads it once.
  const [handed] = useState(() => {
    try {
      sessionStorage.setItem('editInvoiceId', String(invoice.invoice_id));
      return true;
    } catch (e) {
      return false;
    }
  });
  return (
    <Modal isOpen onClose={onClose} title={`Edit ${invoice.invoice_no}`} size="xl" className="variation-edit-invoice"
      closeOnOverlayClick={false} closeOnEscape={false}>
      {handed ? (
        <CreateInvoice isCredit={!!invoice.is_credit} onNavigate={() => onClose()} />
      ) : (
        <p>The editor could not be opened here — open {invoice.invoice_no} from Search Invoices to edit it.</p>
      )}
    </Modal>
  );
}

export default VariationEditInvoice;
